import { DeleteButton } from "features/common/ActionIcons";
import "./VisibilityCondition.less";
import { AnswerDropDown, QuestionDropDown } from "./DropDown";

export default function VisibilityCondition({
    selectedQuestionId,
    selectedAnswerId,
    eligibleQuestionIds,
    existingVisibilityConditionAnswers,
    hideDelete,
    onDeletePredicate,
    onUpdatePredicateQuestion,
    onUpdatePredicateAnswer,
}: {
    selectedQuestionId: string;
    selectedAnswerId: string;
    eligibleQuestionIds: Array<string>;
    existingVisibilityConditionAnswers: Set<string>;
    hideDelete: boolean;
    onDeletePredicate: () => void;
    onUpdatePredicateQuestion: (conditionalQuestionId: string) => void;
    onUpdatePredicateAnswer: (conditionalAnswerId: string) => void;
}) {
    const filteredQuestionIds = [...eligibleQuestionIds];
    if (
        selectedQuestionId &&
        selectedQuestionId !== "" &&
        !filteredQuestionIds.includes(selectedQuestionId)
    ) {
        filteredQuestionIds.push(selectedQuestionId);
    }

    return (
        <div className="VisibilityCondition">
            <div className="dropdowns">
                <div className="dropdown" data-testid="question-dropdown">
                    <QuestionDropDown
                        questionIds={filteredQuestionIds}
                        selectedQuestionId={selectedQuestionId}
                        onUpdate={onUpdatePredicateQuestion}
                    />
                </div>
                <div className="dropdown" data-testid="answer-dropdown">
                    <AnswerDropDown
                        questionId={selectedQuestionId}
                        selectedAnswerId={selectedAnswerId}
                        onUpdate={onUpdatePredicateAnswer}
                        existingVisibilityConditionAnswers={
                            existingVisibilityConditionAnswers
                        }
                    />
                </div>
            </div>
            {!hideDelete && <DeleteButton onDelete={onDeletePredicate} />}
        </div>
    );
}
